var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViviendas = function SvgViviendas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 34,
    fill: "none",
    viewBox: "0 0 50 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#viviendas_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#510C76",
    d: "M38.253 21.979h6.503v10.084a1.6 1.6 0 0 1-1.607 1.587h-4.89V21.973z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#19D3C5",
    d: "m40.258 2.444-5.042 8.624c-.556.947.14 2.136 1.247 2.136h10.084c1.107 0 1.803-1.183 1.247-2.136l-5.042-8.624c-.556-.947-1.944-.947-2.494 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#19D3C5",
    d: "m40.43 8.358-7.255 12.408c-.477.814.122 1.834 1.075 1.834h14.51c.953 0 1.552-1.02 1.075-1.834L42.581 8.358c-.477-.814-1.669-.814-2.146 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#510C76",
    d: "m21.373 0 15.04 10.627h3.882c1.265 0 1.784-1.599.757-2.33L29.306 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.73 10.615H8.648v23.391H38.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.689 0 8.648 10.627H38.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#510C76",
    d: "M30.063 19.257h-7.071c-.604 0-1.094.484-1.094 1.08v12.48c0 .597.49 1.08 1.094 1.08h7.071c.604 0 1.094-.483 1.094-1.08v-12.48c0-.596-.49-1.08-1.094-1.08m-28.56-8.744h11.735v22.346c0 .628-.52 1.141-1.155 1.141H2.659a1.15 1.15 0 0 1-1.156-1.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#19D3C5",
    d: "M15.206 9.91 29.233 0h-14.24c-.814 0-1.602.253-2.262.718L.257 9.528c-.483.345-.238 1.1.354 1.1h12.334c.813 0 1.601-.254 2.261-.719Zm13.843 16.094c.486 0 .88-.39.88-.87a.875.875 0 0 0-.88-.868.875.875 0 0 0-.88.869c0 .48.394.869.88.869"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "viviendas_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50v34H0z"
  })))));
};
export default SvgViviendas;